import * as React from "react";
import { BaseFieldEditor } from "./helper";
import { FieldValueDateTime } from "typings";
import { DatePicker } from "office-ui-fabric-react";

export interface Props extends BaseFieldEditor
{
    value: FieldValueDateTime;
    placeholder?: string;
}

class DateTime extends React.Component<Props>
{
    onChange = (value: Date) =>
    {
        const fieldValue: FieldValueDateTime = {...this.props.value, value};
        this.props.onValueChange(fieldValue);
    }
    render()
    {
        const { value } = this.props;
        const date = value && value.value;
        return <div>
                <DatePicker
                    value={date}
                    placeholder={this.props.placeholder}
                    disabled={this.props.disabled}
                    onSelectDate={this.onChange}
                    showMonthPickerAsOverlay={true}
                    />
        </div>;
    }
}

export default DateTime;


// WEBPACK FOOTER //
// ./src/components/product/FieldEditor/DateTime.tsx